import React, { useState } from 'react'
import { ControlledCustomSelect, CustomTextField, OutlinedTextField } from '../../../../Components/formComponents'
import { IStoreState, useAppDispatch, useAppSelector } from '../../../../redux';
import { fetchOutletsListAsync } from '../../../../redux/settings/outlets';
import { IUserProfile } from '../../../../redux/settings/user-profile';
import { Autocomplete, Paper, TextField } from '@mui/material';

interface IOutletMultiSelectProps {
    value: IUserProfile["outlet_details"]
    onChange: (data: IUserProfile["outlet_details"]) => void
    error?: string
}
export const OutletMultiSelect: React.FC<IOutletMultiSelectProps> = ({
    value,
    onChange,
    error
}) => {
    const customizer = useAppSelector((state: IStoreState) => state.customizer);
    const {
        data: outletsList,
        loading,
    } = useAppSelector((storeState: IStoreState) => storeState.settings.outlets.outlets_list);
    const dispatch = useAppDispatch();

    const [outetsList, setOutetsList] = useState<{ outlet_name: string, outlet_uuid: string }[]>([])

    React.useEffect(() => {
        dispatch(
            fetchOutletsListAsync({
                page: 1,
                rowsPerPage: 1000,
            }),
        );
    }, []);

    React.useEffect(() => {
        const newList = outletsList.map((data) => ({ outlet_name: data.outlet_name || "", outlet_uuid: data.outlet_uuid || "" }))
        setOutetsList(newList)
    }, [outletsList]);

    return (
        <>
            <Autocomplete
                multiple
                id="tags-outlined"
                size='small'
                PaperComponent={({ children }) => (
                    <Paper
                      style={{
                        backgroundColor: customizer.activeMode === "dark" ? "#1E1E1E" : "#ffffff",
                        color: customizer.activeMode === "dark" ? "#fff" : "#000",
                      }}
                    >
                      {children}
                    </Paper>
                  )}
                options={outetsList}
                getOptionLabel={(option) => option.outlet_name}
                filterSelectedOptions
                value={value}
                onChange={(evt, newValue) => {
                    onChange(newValue)
                }}
                renderInput={(params) => (
                    <OutlinedTextField
                        {...params}
                        label="Select Outlets"
                        placeholder="Favorites"
                        // error={!!error}
                        // helperText={error}
                    />
                )}
            />
        </>


    )
}
